import { Mail, Phone, Globe, Instagram, MapPin } from "lucide-react";

interface VenueContactSidebarProps {
  venue: {
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    instagram?: string | null;
    address_street?: string | null;
    address_number?: string | null;
    postal_code?: string | null;
    city: string;
    autonomous_community?: string | null;
  };
}

export function VenueContactSidebar({ venue }: VenueContactSidebarProps) {
  // Parse Instagram: could be full URL or just handle
  const instagramHandle = (() => {
    if (!venue.instagram) return null;
    const raw = venue.instagram.trim().replace(/\/+$/, "");
    // If it's a URL, extract the last path segment
    try {
      const url = new URL(raw.startsWith("http") ? raw : `https://${raw}`);
      const segments = url.pathname.split("/").filter(Boolean);
      if (segments.length > 0) return `@${segments[segments.length - 1]}`;
    } catch {}
    // Already a handle
    const handle = raw.replace(/^@/, "");
    return handle ? `@${handle}` : null;
  })();

  return (
    <div className="space-y-4 text-sm">
      <h3 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
        Contacto y ubicación
      </h3>
      <div className="space-y-2.5">
        {venue.email ? (
          <a href={`mailto:${venue.email}`} className="flex items-center gap-2 hover:underline">
            <Mail className="h-4 w-4 text-muted-foreground" /> {venue.email}
          </a>
        ) : (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Mail className="h-4 w-4" /> Email no disponible
          </div>
        )}
        {venue.phone ? (
          <a href={`tel:${venue.phone}`} className="flex items-center gap-2 hover:underline">
            <Phone className="h-4 w-4 text-muted-foreground" /> {venue.phone}
          </a>
        ) : (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Phone className="h-4 w-4" /> Teléfono no disponible
          </div>
        )}
        {venue.website ? (
          <a href={venue.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:underline">
            <Globe className="h-4 w-4 text-muted-foreground" /> Sitio web
          </a>
        ) : (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Globe className="h-4 w-4" /> Web no disponible
          </div>
        )}
        {instagramHandle ? (
          <a
            href={`https://instagram.com/${instagramHandle.replace("@", "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:underline"
          >
            <Instagram className="h-4 w-4 text-muted-foreground" /> {instagramHandle}
          </a>
        ) : (
          <div className="flex items-center gap-2 text-muted-foreground">
            <Instagram className="h-4 w-4" /> Instagram no disponible
          </div>
        )}
        <div className="flex items-start gap-2 text-muted-foreground">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0" />
          <span>
            {[
              [venue.address_street, venue.address_number].filter(Boolean).join(" "),
              venue.postal_code,
              venue.city,
              venue.autonomous_community,
            ].filter(Boolean).join(", ")}
          </span>
        </div>
      </div>
    </div>
  );
}
